import { useState } from "react";
import { sortRows } from "@/utils/sort";
export function useTableSort(rows, selectors, initialKey, initialDirection = "asc") {
    const [sort, setSort] = useState({ key: initialKey, direction: initialDirection });
    const toggleSort = (key) => setSort((previous) => ({
        key,
        direction: previous.key === key && previous.direction === "asc" ? "desc" : "asc",
    }));
    return { sortedRows: sortRows(rows, selectors[sort.key], sort.direction), sort, toggleSort };
}
